
document.addEventListener('DOMContentLoaded', function() {
  const kiyohWidgetHeader = document.querySelector('.kiyoh-widget-header');
  const productRatingVendors = document.querySelectorAll('[data-product-rating-vendor]');

  if (!kiyohWidgetHeader && productRatingVendors.length === 0) {
    return;
  }

  // Hide widgets initially until data loads
  if (kiyohWidgetHeader) {
    kiyohWidgetHeader.style.display = 'none';
  }

  const xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const xmlResponse = xhr.responseXML;
      const numberReviewsElement = xmlResponse.getElementsByTagName("numberReviews")[0];
      const averageRatingElement = xmlResponse.getElementsByTagName("averageRating")[0];

      if (!numberReviewsElement || !averageRatingElement) {
        console.error('Kiyoh XML response missing required elements');
        return;
      }

      const totalReviewNumber = numberReviewsElement.textContent;
      const totalReviewScore = parseFloat(averageRatingElement.textContent);

      // Populate widget elements
      const scoreElement = document.querySelector('[data-kiyoh-score]');
      const countElement = document.querySelector('[data-kiyoh-count]');

      if (scoreElement) {
        scoreElement.textContent = totalReviewScore.toFixed(1);
      }

      if (countElement) {
        countElement.textContent = totalReviewNumber;
      }

      // Render header widget
      if (kiyohWidgetHeader) {
        renderStars(totalReviewScore);
        kiyohWidgetHeader.style.display = '';
      }

      // Render product rating with vendor
      productRatingVendors.forEach(function(el) {
        renderProductRatingVendor(totalReviewScore, totalReviewNumber, el);
      });

      // Create structured data
      const AggregateRatingData = `{
"@context": "https://schema.org",
"@type": "AggregateRating",
"itemReviewed": {
    "@type": "Organization",
    "image": "https://cdn.webshopapp.com/shops/271062/themes/150771/v/1791096/assets/logo.png",
    "name": "123impregneer.nl",
    "telephone": "+31(0)573-795264",
    "address": {
        "@type": "PostalAddress",
        "streetAddress": "De Vente 1E",
        "addressLocality": "Ruurlo",
        "addressRegion": "Gelderland",
        "addressCountry": "NL",
        "postalCode": "7261 ST"
    }
},
"ratingValue": "${totalReviewScore}",
"bestRating": "10",
"ratingCount": "${totalReviewNumber}"
}`;

      const script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.textContent = AggregateRatingData;
      document.head.appendChild(script);
    } else if (xhr.readyState === 4 && xhr.status !== 200) {
      console.error('Error fetching Kiyoh reviews:', xhr.status, xhr.statusText);
    }
  };

  xhr.open("GET", "https://www.kiyoh.com/v1/review/feed.xml?hash=gnbsoiynpcuvmxg", true);
  xhr.send();

  function renderStars(reviewScore) {
    // Kiyoh uses 0-10 scale, convert to 0-5 for stars
    const scoreOutOf5 = reviewScore / 2;
    const fullStars = Math.floor(scoreOutOf5);
    const hasHalfStar = scoreOutOf5 % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    let starsHTML = '';

    for (let i = 0; i < fullStars; i++) {
      starsHTML += "<i class='bx bxs-star'></i>";
    }

    if (hasHalfStar) {
      starsHTML += "<i class='bx bxs-star-half'></i>";
    }

    for (let i = 0; i < emptyStars; i++) {
      starsHTML += "<i class='bx bx-star'></i>";
    }

    const starsElement = document.querySelector('[data-kiyoh-stars]');
    if (starsElement) {
      starsElement.innerHTML = starsHTML;
    }
  }

  function renderProductRatingVendor(reviewScore, totalReviews, element) {
    const vendor = element.getAttribute('data-vendor');
    const sku = element.getAttribute('data-sku');

    // Convert Kiyoh 0-10 scale to 0-5 for stars
    const scoreOutOf5 = reviewScore / 2;
    const fullStars = Math.floor(scoreOutOf5);
    const hasHalfStar = scoreOutOf5 % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    // Build stars HTML
    let starsHTML = '';
    for (let i = 0; i < fullStars; i++) {
      starsHTML += '★';
    }
    if (hasHalfStar) {
      starsHTML += '⯨'; // Half star character
    }
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += '☆';
    }

    // Format the HTML: Only stars and reviews are clickable
    element.innerHTML = `
      <span class="rating-clickable" style="cursor: pointer; text-decoration: none; transition: text-decoration 0.2s ease;">
        <span style="color: #f5a623; font-size: 1.4rem; letter-spacing: 0.1rem;">${starsHTML}</span>
        <span style="font-weight: 600;">${reviewScore.toFixed(1).replace('.', ',')}/10</span>
        <span style="margin-left: 0.5rem;">(${totalReviews.toLocaleString('nl-NL')} reviews)</span>
      </span>
      ${vendor ? `<span style="margin: 0 0.6rem; opacity: 0.5;">|</span><span>${vendor}</span>` : ''}
    `;

    // Show the element
    element.style.display = 'block';

    // Make only rating part clickable with hover effect
    const clickableRating = element.querySelector('.rating-clickable');
    if (clickableRating) {
      clickableRating.addEventListener('click', function() {
        const testimonialsSection = document.querySelector('[id*="testimonials"], [class*="testimonials"]');
        if (testimonialsSection) {
          testimonialsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      // Add underline hover effect
      clickableRating.addEventListener('mouseenter', function() {
        this.style.textDecoration = 'underline';
      });
      clickableRating.addEventListener('mouseleave', function() {
        this.style.textDecoration = 'none';
      });
    }
  }
});

// Description Preview - Scroll to full description
document.addEventListener('DOMContentLoaded', function() {
  const descriptionPreviewLink = document.querySelector('[data-description-scroll]');

  if (descriptionPreviewLink) {
    descriptionPreviewLink.addEventListener('click', function(e) {
      e.preventDefault();

      // Find the full description section (collapsible-expandable element containing description)
      const descriptionSection = document.querySelector('collapsible-expandable .facet');

      if (descriptionSection) {
        descriptionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
});

// Collection Categories Scroller
class CategoryScroller {
  constructor(wrapper) {
    this.container = wrapper.querySelector('.collection-categories__container');
    this.list = wrapper.querySelector('.collection-categories__list');
    this.prevButton = wrapper.querySelector('.collection-categories__nav--prev');
    this.nextButton = wrapper.querySelector('.collection-categories__nav--next');

    if (!this.container || !this.list || !this.prevButton || !this.nextButton) return;

    this.init();
  }

  init() {
    this.checkScrollability();
    this.bindEvents();
  }

  bindEvents() {
    // Check scrollability on window resize
    window.addEventListener('resize', () => this.checkScrollability());

    // Update button states on scroll
    this.container.addEventListener('scroll', () => this.updateButtonStates());

    // Button click handlers
    this.prevButton.addEventListener('click', () => this.scroll('left'));
    this.nextButton.addEventListener('click', () => this.scroll('right'));
  }

  checkScrollability() {
    const isScrollable = this.list.scrollWidth > this.container.clientWidth;

    if (isScrollable) {
      this.container.classList.add('is-scrollable');
      this.updateButtonStates();
    } else {
      this.container.classList.remove('is-scrollable');
      this.prevButton.classList.remove('is-visible');
      this.nextButton.classList.remove('is-visible');
    }
  }

  updateButtonStates() {
    const scrollLeft = this.container.scrollLeft;
    const maxScroll = this.list.scrollWidth - this.container.clientWidth;

    this.prevButton.classList.toggle('is-visible', scrollLeft > 0);
    this.nextButton.classList.toggle('is-visible', scrollLeft < maxScroll);
  }

  scroll(direction) {
    const scrollAmount = this.container.clientWidth * 0.8;
    const currentScroll = this.container.scrollLeft;

    this.container.scrollTo({
      left: direction === 'left'
        ? currentScroll - scrollAmount
        : currentScroll + scrollAmount,
      behavior: 'smooth'
    });
  }
}

// Initialize on document ready
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.collection-categories').forEach(function(el) {
    new CategoryScroller(el);
  });
});

// USP Slider for Mobile
class USPSlider {
  constructor() {
    this.uspElements = document.querySelectorAll('.layout-usps');
    this.sliders = [];
    this.breakpoint = 990;

    if (this.uspElements.length === 0) return;

    this.init();
  }

  init() {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.handleResize());
  }

  checkScreenSize() {
    const isMobile = window.innerWidth < this.breakpoint;

    if (isMobile) {
      this.initSliders();
    } else {
      this.destroySliders();
    }
  }

  initSliders() {
    // Check if Flickity is loaded
    if (typeof Flickity === 'undefined') {
      console.warn('Flickity not loaded, USP slider cannot initialize');
      return;
    }

    this.uspElements.forEach((element) => {
      // Don't reinitialize if already a slider
      if (element.classList.contains('flickity-enabled')) return;

      // Check if there are enough items to slide
      const items = element.querySelectorAll('.layout-usp');
      if (items.length <= 1) return;

      // Initialize Flickity
      const slider = new Flickity(element, {
        cellAlign: 'center',
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        autoPlay: 3000,
        pauseAutoPlayOnHover: true,
        draggable: true,
        freeScroll: false,
        adaptiveHeight: false,
        imagesLoaded: false,
        percentPosition: true
      });

      this.sliders.push(slider);
    });
  }

  destroySliders() {
    this.sliders.forEach(slider => {
      if (slider && typeof slider.destroy === 'function') {
        slider.destroy();
      }
    });
    this.sliders = [];
  }

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.checkScreenSize();
    }, 250);
  }
}

// Initialize USP Slider
document.addEventListener('DOMContentLoaded', function() {
  new USPSlider();
});

// CBB Frequently Bought Together — Restructure into card grid
(function() {
  function restructureCBB() {
    var container = document.querySelector('.cbb-frequently-bought-container');
    if (!container || container.classList.contains('cbb-card-layout')) return;

    var products = container.querySelectorAll('.cbb-frequently-bought-product');
    var listItems = container.querySelectorAll('.cbb-frequently-bought-selector-list li');

    if (listItems.length === 0) return;

    // If fewer images than list items, first li is main product without an image in the row
    var offset = listItems.length > products.length ? 1 : 0;

    listItems.forEach(function(li, index) {
      var productIndex = index - offset;

      // Clone full product image element into the card
      if (productIndex >= 0 && productIndex < products.length) {
        var imageLink = products[productIndex].querySelector('.cbb-frequently-bought-product-image-link');
        if (imageLink) {
          var clone = imageLink.cloneNode(true);
          clone.classList.add('cbb-card-image');
          clone.removeAttribute('href');
          clone.style.pointerEvents = 'none';
          li.insertBefore(clone, li.firstChild);
        }
      }

      // First item = main product
      if (index === 0) {
        li.classList.add('cbb-card-main-product');

        // If main product still has no image, grab from the product page gallery
        if (!li.querySelector('.cbb-card-image')) {
          var pageImg = document.querySelector('.product-media-main.is-active img');
          if (pageImg) {
            var wrapper = document.createElement('div');
            wrapper.className = 'cbb-card-image';
            var newImg = pageImg.cloneNode(true);
            wrapper.appendChild(newImg);
            li.insertBefore(wrapper, li.firstChild);
          }
        }
      }

      // Make add-on cards clickable to toggle checkbox (not main product)
      if (index > 0) {
        li.addEventListener('click', function(e) {
          if (e.target.tagName === 'INPUT') return;
          var checkbox = li.querySelector('input[type="checkbox"]');
          if (checkbox) checkbox.click();
        });
      }

      li.classList.add('cbb-card-item');
    });

    // Hide original products row
    var productsRow = container.querySelector('.cbb-frequently-bought-products');
    if (productsRow) productsRow.style.display = 'none';

    // Mark as restructured
    container.classList.add('cbb-card-layout');
  }

  // CBB app loads async — observe for it
  var observer = new MutationObserver(function() {
    var container = document.querySelector('.cbb-frequently-bought-container');
    if (container && !container.classList.contains('cbb-card-layout')) {
      restructureCBB();
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    restructureCBB();
    setTimeout(restructureCBB, 1500);
    setTimeout(restructureCBB, 3000);
  });

  // Open mini cart after CBB bundle add-to-cart
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cbb-frequently-bought-add-button');
    if (!btn) return;

    // Get current cart count, then poll until it changes
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var startCount = cart.item_count;
      var attempts = 0;
      var maxAttempts = 20;

      var poll = setInterval(function() {
        attempts++;
        if (attempts >= maxAttempts) {
          clearInterval(poll);
          return;
        }
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(newCart) {
          if (newCart.item_count !== startCount) {
            clearInterval(poll);
            if (window.miniCart) {
              window.miniCart.updateSectionContents().then(function() {
                window.miniCart.open();
              });
            }
          }
        });
      }, 500);
    });
  });
})();
